import styled from 'util/style'

const FooterSection = styled.div`
  flex: 1;
  text-align: center;
  margin: 0 20px;

  a {
    display: block;
    color: #333;
    margin-bottom: 6px;
    text-decoration: none;
    padding-bottom: 1px solid transparent;
    transition: .1 ease-in-out border-bottom-color;

    &:hover {
      border-bottom-color: #999;
    }
  }
`

export default FooterSection
